"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./ripple.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Get coordinates of mouse or touch event relative to the element that was
// clicked or touched.
var getRelativeCoordinates = function getRelativeCoordinates(_ref) {
  var ev = _ref.ev,
    element = _ref.element;
  if (!element) return {
    x: 0,
    y: 0
  };
  var bounds = element.getBoundingClientRect();
  var _ref2 = ev.touches ? ev.touches[0] : ev,
    pageX = _ref2.pageX,
    pageY = _ref2.pageY;
  return {
    x: pageX - (window.scrollX || window.pageXOffset) - bounds.left,
    y: pageY - (window.scrollY || window.pageYOffset) - bounds.top
  };
};
var Ripple = /*#__PURE__*/function (_Component) {
  function Ripple() {
    var _this;
    _classCallCheck(this, Ripple);
    _this = _callSuper(this, Ripple);
    _this.state = {
      active: false,
      origin: {}
    };
    _this.activate = _this.activate.bind(_this);
    _this.handleAnimationEnd = _this.handleAnimationEnd.bind(_this);
    _this.mergeEventHandlers = _this.mergeEventHandlers.bind(_this);
    return _this;
  }

  // Set default props
  _inherits(Ripple, _Component);
  return _createClass(Ripple, [{
    key: "activate",
    value: function activate(ev) {
      var _this$props$container,
        _this2 = this;
      // Return early if Ripple has been activated through a touchstart event
      // and is now being activated again by a mousedown. This prevents a double
      // event from the touchstart and mousedown listeners.
      //
      // Typically this wouldn't be necessary, because calling ev.preventDefault
      // on a touchstart event prevents the subsequent mousedown event from
      // firing. This doesn't work in React + Chrome at the moment because
      // Chrome sets touch listeners to passive by default (which doesn't
      // support preventDefault) and React does not yet provide a way to make
      // these listeners active again.
      if (this.state.active && this.touchStarted && ev.type === 'mousedown') {
        this.touchStarted = false;
        return;
      }
      this.touchStarted = ev.type === 'touchstart';
      var newState = {
        active: true,
        origin: getRelativeCoordinates({
          ev: ev,
          element: (_this$props$container = this.props.containerRef) === null || _this$props$container === void 0 ? void 0 : _this$props$container.current
        })
      };

      // Cancel current animation if it's running, then trigger a new one.
      if (this.state.active) {
        this.deactivate(function () {
          _this2.setState(newState);
        });
        return;
      }
      this.setState(newState);
    }
  }, {
    key: "deactivate",
    value: function deactivate(callback) {
      this.setState({
        active: false,
        origin: {}
      }, callback);
    }
  }, {
    key: "handleAnimationEnd",
    value: function handleAnimationEnd() {
      this.deactivate();
    }
  }, {
    key: "getEventHandlers",
    value: function getEventHandlers() {
      return {
        onMouseDown: this.activate,
        onTouchStart: this.activate
      };
    }
  }, {
    key: "mergeEventHandlers",
    value: function mergeEventHandlers(props) {
      var eventHandlers = this.getEventHandlers();
      var onTouchStart = props.onTouchStart,
        onMouseDown = props.onMouseDown;
      return {
        onTouchStart: onTouchStart ? function (ev) {
          eventHandlers.onTouchStart(ev);
          onTouchStart(ev);
        } : eventHandlers.onTouchStart,
        onMouseDown: onMouseDown ? function (ev) {
          eventHandlers.onMouseDown(ev);
          onMouseDown(ev);
        } : eventHandlers.onMouseDown
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        active = _this$state.active,
        origin = _this$state.origin;
      var defaultBgClass = this.props.dark ? 'bg-black50' : 'bg-white';
      var bgClass = this.props.backgroundClassName ? this.props.backgroundClassName : defaultBgClass;
      var ripple = active ? /*#__PURE__*/_react["default"].createElement("span", {
        className: "sb-ripple position-absolute ".concat(bgClass, " ").concat(this.props.className),
        onAnimationEnd: this.handleAnimationEnd,
        style: {
          top: origin.y || 0,
          left: origin.x || 0
        }
      }) : undefined;
      return this.props.children({
        ripple: ripple,
        eventHandlers: this.getEventHandlers(),
        mergeEventHandlers: this.mergeEventHandlers
      });
    }
  }]);
}(_react.Component);
_defineProperty(Ripple, "defaultProps", {
  children: function children() {}
});
Ripple.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Overrides the background class */
  backgroundClassName: _propTypes["default"].string,
  /**
   * Function returning properties used to render the ripple
   * and apply required event listeners to the ripple's parent.
   * Returns an object with the following properties:
   *
   * - `ripple`: The renderable React ripple element. Place within
   *   the element that should ripple. Note: the element containing
   *   the ripple must have `position: relative`. It can optionally
   *   use `overflow: hidden` to keep the ripple within the bounds
   *   of the element.
   * - `eventHandlers`: Event handlers used to enable ripples.
   *   Pass to the element that should ripple.
   * - `mergeEventHandlers`: A function used to create ripple event
   *   handlers merged with event handlers from element that should
   *   ripple. Takes `props` of target element as parameter, and returns
   *   `eventHandlers` object. This function is only necessary if the
   *   component using ripple must support its own `onTouchStart` and
   *   `onMouseDown` event handlers. Otherwise, just use the
   *   `eventHandlers` property.
   */
  children: _propTypes["default"].func.isRequired,
  /**
   * Inverts ripple color scheme, making it dark instead of light.
   */
  dark: _propTypes["default"].bool,
  /**
   *  This ref should be attached to the parent element that will contain the ripple effect.
   *  The ripple's position will be calculated relative to this container's bounds.
   */
  containerRef: _propTypes["default"].object
} : {};
var _default = exports["default"] = Ripple;